// extracted by mini-css-extract-plugin
export default {"focusContainer":"focusContainer__ddvCe"};